import React from 'react';
import { connect } from 'react-redux';

import getSidebarQualities from 'selectors/myself/getSidebarQualities';

import SidebarQuality from './components/SidebarQuality';

import { buildTooltipData } from './utils';
import { IAppState } from 'types/app';
import { IQuality } from 'types/qualities';

type Props = ReturnType<typeof mapStateToProps>;

export function Qualities({ qualities }: Props) {
  return (
    <ul className="items items--list">
      {qualities.map((q: IQuality) => (<SidebarQuality key={q.id} {...q} tooltipData={buildTooltipData({ ...q, useCap: true })} />))}
    </ul>
  );
}

Qualities.displayName = 'Qualities';

const mapStateToProps = (state: IAppState) => ({ qualities: getSidebarQualities(state) });

export default connect(mapStateToProps)(Qualities);